import React from 'react';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { usePlateLayoutEditorContext } from 'client/app/components/Parameters/PlateLayout/PlateLayoutEditorProvider';

export function SetupHelperText() {
  const { plateType } = usePlateLayoutEditorContext();
  const helperContent = plateType ? (
    <>
      Switch to the <StrongTypography>Liquids</StrongTypography> tab to start adding
      contents to the plate
    </>
  ) : (
    <>
      Select a <StrongTypography>Plate Type</StrongTypography> to start editing
    </>
  );
  return (
    <>
      <StyledTypography>{helperContent}</StyledTypography>
      <StyledArrowRightAltIcon />
    </>
  );
}

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginLeft: 'auto',
}));

const StrongTypography = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 'bold',
}));

const StyledArrowRightAltIcon = styled(ArrowRightAltIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '24px',
}));
